import styled from 'styled-components';

export const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #272727;

  div {
    color: #272727;
  }

  .editor-wrapper {
    position: relative;
    border: 1px solid #9a9a9a;
    border-radius: 18px;
    background: #ffffff;
    overflow: hidden;
    transition: border-color 0.2s;

    &:focus-within {
      border-color: #272727;
    }
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;

    p {
      color: #272727;
      font-size: 16px;
      font-weight: 500;
    }
  }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
  position: relative;

  .divider {
    width: 1px;
    height: 20px;
    background-color: #cbd5e1;
    margin: 0 4px;
  }
`;

export const ToolbarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #4b5563;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: #e5e7eb;
    color: #111827;
  }

  &:active {
    background-color: #d1d5db;
  }
`;

export const LinkInputPopover = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  left: 10px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  padding: 8px;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border: 1px solid #e2e8f0;

  input {
    height: 32px !important;
    padding: 0 10px !important;
    border-radius: 8px !important;
    border: 1px solid #cbd5e1 !important;
    font-size: 13px !important;
    width: 220px;
    outline: none;

    &:focus {
      border-color: #3b82f6 !important;
    }
  }

  button {
    height: 32px;
    padding: 0 12px;
    border-radius: 8px;
    border: none;
    background-color: #0284c7;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background-color: #0369a1;
    }

    &.cancel {
      background-color: #e2e8f0;
      color: #475569;

      &:hover {
        background-color: #cbd5e1;
      }
    }
  }
`;

export const EditorContent = styled.div`
  min-height: 220px;
  max-height: 450px;
  overflow-y: auto;
  padding: 14px 16px;
  font-size: 15px;
  line-height: 1.6;
  color: #272727 !important;
  outline: none;

  * {
    color: #272727;
  }

  &[contenteditable='true']:empty:before {
    content: attr(data-placeholder);
    color: #9a9a9a;
    pointer-events: none;
    display: block;
  }

  a {
    color: #0284c7 !important;
    text-decoration: underline;
    cursor: pointer;
  }

  b,
  strong {
    font-weight: bold;
  }

  i,
  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }

  p {
    margin-bottom: 8px;
  }

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 4px;
  }
`;
